
<template>
  <base-section
    id="news"
    space="72"
  >
    <v-container>
      <v-row justify="center">
        <v-col
          cols="12"
          md="6"
        >
          <news-card
            v-for="(article, i) in articles"
            :key="i"
            :divider="i + 1 < articles.length"
            class="mb-12"
            v-bind="article"
          />
          <v-pagination
            v-if="totalPages > 1"
            v-model="page"
            :length="totalPages"
            total-visible="7"
            @input="loadArticles"
          />
        </v-col>

        <v-col
          cols="12"
          md="3"
        >
          <news-search />

          <news-categories />

          <news-archives />

          <news-tags />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionNewsAlt',

    components: {
      NewsArchives: () => import('@/components/news/Archives'),
      NewsCard: () => import('@/components/news/Card'),
      NewsCategories: () => import('@/components/news/Categories'),
      NewsSearch: () => import('@/components/news/Search'),
      NewsTags: () => import('@/components/news/Tags'),
    },

    data: () => ({
      articles: [],
      page: 1,
      size: 6,
      total: 0,
      categoryMap: {},
    }),

    computed: {
      totalPages() {
        return Math.max(1, Math.ceil(this.total / this.size))
      },
    },

    watch: {
      '$i18n.locale'() {
        this.page = 1
        this.loadTaxonomies()
        this.loadArticles()
      },
    },

    async mounted() {
      await this.loadTaxonomies()
      await this.loadArticles()
    },

    methods: {
      slugify(text) {
        if (!text) return ''
        return text
          .toString()
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
      },
      buildMap(list) {
        if (!Array.isArray(list)) return {}
        return list.reduce((acc, item) => {
          if (item && item.dictValue) {
            acc[item.dictValue] = item.dictLabel
          }
          return acc
        }, {})
      },
      async loadTaxonomies() {
        try {
          const resp = await this.$axios({ method: 'get', url: '/public/dict/data', params: { dictType: 'sys_blog_category' } })
          const categories = Array.isArray(resp) ? resp : (resp?.data || resp?.items || [])
          this.categoryMap = this.buildMap(categories)
        } catch (error) {
          this.categoryMap = {}
        }
      },
      mapCategory(value) {
        if (!value) return 'Blog'
        return this.categoryMap[value] || value
      },
      pickLocalizedRows(items) {
        const locale = this.$i18n.locale || 'en'
        const groups = new Map()
        for (const item of (items || [])) {
          if (!item) continue
          const key = item.groupKey || `id-${item.id}`
          const list = groups.get(key) || []
          list.push(item)
          groups.set(key, list)
        }
        const picked = []
        for (const list of groups.values()) {
          const current = list.find(row => row.lang === locale)
          const fallbackEn = list.find(row => row.lang === 'en')
          picked.push(current || fallbackEn || list[0])
        }
        return picked
      },
      async loadArticles() {
        try {
          const resp = await this.$axios({
            method: 'get',
            url: '/public/blog',
            params: { lang: this.$i18n.locale, page: this.page, size: this.size },
          })
          const items = (resp && resp.items) ? resp.items : (resp || [])
          const localized = this.pickLocalizedRows(items)
          const displayItems = [...localized]
            .filter(item => item && item.visible !== false)
            .sort((a, b) => (Number(a?.sortOrder || 0) - Number(b?.sortOrder || 0)) || (Number(b?.id || 0) - Number(a?.id || 0)))
          this.total = (resp && typeof resp.total === 'number') ? resp.total : displayItems.length
          this.articles = displayItems.map(item => ({
            icon: 'mdi-text',
            date: item.publishAt,
            category: this.mapCategory(item.category),
            comments: 0,
            title: item.title,
            text: item.excerpt,
            src: item.coverImage || require('@/assets/logo/logo.png'),
            id: item.id,
            slug: item.slug || (item.id ? `${item.id}-blog-${item.id}` : ''),
          }))
        } catch (error) {
          this.articles = []
          this.total = 0
        }
      },
    },
  }
</script>
